"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButtonWidget = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var ButtonWidget_1 = require("./ButtonWidget");
var MenuButtonWidget_1 = require("./MenuButtonWidget");
var ButtonStyleName = TypeStyle.style({
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: "0 !important",
});
var MenuButtonStyleName = TypeStyle.style({
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    marginLeft: "1px !important",
    minWidth: "24px !important",
});
/** A component which visually groups a `ButtonWidget` with a `MenuButtonWidget`. */
var SplitButtonWidget = function (props) {
    MenuButtonWidget_1.validateMenuButtonProps(props.menuButton.props);
    return React.createElement("div", { style: { display: 'inline-flex', whiteSpace: 'nowrap' } },
        React.cloneElement(props.button, {
            buttonType: ButtonWidget_1.ButtonType.Primary,
            className: TypeStyle.classes(props.button.props.className, ButtonStyleName),
            density: props.button.props.density || 'medium',
        }),
        React.cloneElement(props.menuButton, {
            kind: 'primary',
            className: TypeStyle.classes(props.menuButton.props.className, MenuButtonStyleName),
            density: 'high',
        }));
};
exports.SplitButtonWidget = SplitButtonWidget;
exports.SplitButtonWidget.displayName = 'SplitButtonWidget';
//# sourceMappingURL=SplitButtonWidget.js.map